import React from "react";
import NavigationRoutes from "./Components/Routes/Routes";

const App = () => (
  <>
    <div className="text-center bg-white">
      <NavigationRoutes />
    </div>
  </>
)
export default App;
